/* src/app/components/header/header.component.css */
.header {
  background: #EB0029;
  min-height: 68px;
  display: flex;
  align-items: center;
  padding: 0 54px;
  justify-content: space-between;
}
@media (max-width: 473.5px) {
  .header {
    padding: 0 16px;
  }
}
.navbar {
  display: inline-flex;
  align-items: center;
  padding: 0;
}
.navbar-collapse {
  flex-direction: column;
}
.nav-link:hover {
  background-color: #D80026;
}
.nav-link {
  font-family: "Gotham Book";
  font-size: 15px;
  color: #FFFFFF;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 16px !important;
}
.nav-link.active {
  background-color: #CC0024;
}
.nav-item {
  height: 68px;
  align-items: center;
}
.nav-item.quienes-somos {
  width: auto;
}
.nav-item.conoce-mas {
  width: auto;
}
.nav-item.directorio {
  width: auto;
}
.dropdown-menu {
  width: 217px;
  padding: 10px 0px;
  flex-direction: column;
  align-items: center;
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 4px 10px 0px rgba(50, 62, 72, 0.15);
}
.dropdown.show .dropdown-menu {
  display: block;
}
.dropdown-item {
  font-family: "Gotham Book";
  font-size: 15px;
  color: #5B6670;
  padding: 10px 20px;
  width: 100%;
  height: 45px;
}
.dropdown-item:hover {
  background-color: #F4F7F8;
  color: #EB0029;
  font-family: "Gotham Medium";
  font-size: 15px;
}
.subheader {
  height: 54px;
  background-color: #FCFCFC;
  padding: 0 54px;
  display: flex;
  box-sizing: border-box;
  align-items: center;
}
@media (max-width: 473.5px) {
  .subheader {
    padding: 0 16px;
  }
}
.inmuebles-title {
  color: #5B6670;
  font-family: "Gotham Medium";
  font-size: 17px;
  font-style: normal;
  line-height: normal;
  margin: 0;
  padding: 0;
}
.breadcrumb-container {
  height: auto;
  padding: 16px 54px;
  background-color: #F4F7F8;
  box-sizing: border-box;
  box-shadow: 0px 4px 10px 0px rgba(50, 62, 72, 0.10);
  position: relative;
  z-index: -1;
}
@media (max-width: 473.5px) {
  .breadcrumb-container {
    padding: 16px 16px;
  }
}
.breadcrumb-link {
  font-family: "Gotham Medium";
  font-size: 15px;
  line-height: 20px;
  color: #323E48;
  text-decoration: none;
}
.breadcrumb-item {
  font-family: "Gotham Medium";
  font-size: 15px;
  line-height: 20px;
  color: #323E48;
}
.breadcrumb-last {
  font-family: "Gotham Medium";
  font-size: 15px;
  line-height: 20px;
  color: #EB0029;
}
.breadcrumb-icon {
  margin: 0 10px;
}
@media (min-width: 992px) {
  .navbar {
    display: flex;
    align-items: center;
  }
  .arrow {
    filter: brightness(0) invert(1);
  }
}
@media (max-width: 991.5px) {
  .nav-link {
    color: #323E48;
  }
  .nav-link.active,
  .nav-link:hover {
    background-color: #F4F7F8;
    color: #EB0029;
    font-family: "Gotham Medium";
  }
  .nav-link.active .arrow,
  .nav-link:hover .arrow {
    filter: invert(11%) sepia(99%) saturate(7487%) hue-rotate(349deg) brightness(94%) contrast(108%);
  }
}
.img-fluid {
  width: 194px;
  height: 59px;
}
.offcanvas {
  background-color: white;
  width: auto;
  min-width: 250px;
  height: 325px;
  top: 68px;
  border-radius: 8px;
}
.arrow {
  transition: transform .3s ease;
}
.arrow.open {
  transform: rotateX(180deg);
}
.navbar-toggler:focus {
  outline: none;
  box-shadow: none;
}
/*# sourceMappingURL=/banorte/__host/inmuebles/Inmuebles/header.component.css.map */
